import { vs2ngaLimitedReleasesListConstants } from "../_redux-constants";
import { vs2ngaLimitedReleasesListService } from "../../_services";

function getVs2ngaLimitedReleasesList(queryParams) {
  function getVs2ngaLimitedReleasesListLoad() {
    return {
      type: vs2ngaLimitedReleasesListConstants.VS2NGA_LIMITED_RELEASES_LIST_LOADING,
    };
  }
  function getVs2ngaLimitedReleasesListSuccess(data) {
    return {
      type: vs2ngaLimitedReleasesListConstants.VS2NGA_LIMITED_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function getVs2ngaLimitedReleasesListFailure(error) {
    return {
      type: vs2ngaLimitedReleasesListConstants.VS2NGA_LIMITED_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getVs2ngaLimitedReleasesListLoad());
    return vs2ngaLimitedReleasesListService
      .getVs2ngaLimitedReleasesList(queryParams)
      .then(
        (data) => {
          dispatch(getVs2ngaLimitedReleasesListSuccess(data));
        },
        (error) => {
          dispatch(getVs2ngaLimitedReleasesListFailure(error?.toString()));
        }
      );
  };
}

export const vs2ngaLimitedReleasesListActions = {
  getVs2ngaLimitedReleasesList,
};
